
import React from 'react';

import Card from './Card';
import DeviceImage from './DeviceImage';

export default ({
  device,
  device: { lob },
}) => (
  <div className="card-group__item">
    <Card className="card--secondary">
      <div className="order-item">
        <div className="order-item__image">
          <DeviceImage device={device} />
        </div>
        <div className="order-item__content">
          <h3 className="body1">
            {
              lob === 'video' ? 'New TV Box' : 'New Modem'
            }
          </h3>
        </div>
      </div>
    </Card>
  </div>
);
